<template>
  <nav id="sidebar" class="nav-sidebar">
    <ul class="list-unstyled components" id="accordion">
      <!-- <div class="user-profile">
        
        <div class="dropdown user-pro-body">
          <div>
            <img src="@/assets/images/head-banner.png" alt="user-img" style="border: none;width: 60px;">
          </div>
          <div></div>
        </div>
      </div> -->

      <!-- 企业菜单 -->
      <li v-if="currentUserType=='enterprise'">
        <router-link to="/home" :class="selectIndex=='home'?'accordion-toggle wave-effect select-menu':'accordion-toggle wave-effect'"  data-toggle="collapse">
          <img src="@/assets/images/menu/menu-sy.png" style="width:16px;margin-right:15px;">首页
        </router-link>
      </li>
      <li v-if="currentUserType=='enterprise'">
        <router-link to="/data/center" :class="selectIndex=='data'?'accordion-toggle wave-effect select-menu':'accordion-toggle wave-effect'"  data-toggle="collapse">
          <img src="@/assets/images/menu/menu-dsj.png" style="width:16px;margin-right:15px;">Hiturn大数据
        </router-link>
      </li>
      <!-- <li v-if="currentUserType=='enterprise'">
        <router-link  :to="{path: '/map/hiturn_map'}" target="_blank"  class="accordion-toggle wave-effect">
          <img src="@/assets/images/menu/menu-yzph.png" style="width:16px;margin-right:15px;">人才地图
        </router-link>
      </li> -->
      <li v-if="currentUserType=='enterprise'">
        <!-- <router-link to="/cv/cv_manager" :class="selectIndex=='cv'?'accordion-toggle wave-effect select-menu':'accordion-toggle wave-effect'"  data-toggle="collapse"> -->
        <router-link to="/job/job_apply_list/999999999/0" :class="selectIndex=='cv'?'accordion-toggle wave-effect select-menu':'accordion-toggle wave-effect'"  data-toggle="collapse">
          <img src="@/assets/images/menu/menu-jlgl.png" style="width:16px;margin-right:15px;">简历管理
        </router-link>
      </li>
      <li v-if="currentUserType=='enterprise'">
        <router-link to="/job/job_manager" :class="selectIndex=='job'?'accordion-toggle wave-effect select-menu':'accordion-toggle wave-effect'"  data-toggle="collapse">
          <img src="@/assets/images/menu/menu-zwgl.png" style="width:16px;margin-right:15px;">职位管理
        </router-link>
      </li>
      <li v-if="currentUserType=='enterprise'">
        <router-link to="/index?pageFrom=cvView" :class="selectIndex=='index'?'accordion-toggle wave-effect select-menu':'accordion-toggle wave-effect'"  data-toggle="collapse">
          <img src="@/assets/images/menu/menu-rcss.png" style="width:16px;margin-right:15px;">人才搜索
        </router-link>
      </li>
      <li v-if="currentUserType=='enterprise'">
        <router-link to="/enterprise/interview_manage" :class="(fullPath=='/enterprise/enterprise_interview_list'|| selectIndex=='ai' || selectIndex=='tools' || fullPath=='/enterprise/interview_manage')?'accordion-toggle wave-effect select-menu':'accordion-toggle wave-effect'"  data-toggle="collapse">
          <img src="@/assets/images/menu/menu-msgl.png" style="width:16px;margin-right:15px;">面试管理
        </router-link>
      </li>
      <li v-if="currentUserType=='enterprise'">
        <router-link to="/exam/exam_manager" :class="selectIndex=='exam'?'accordion-toggle wave-effect select-menu':'accordion-toggle wave-effect'"  data-toggle="collapse">
          <img src="@/assets/images/menu/menu-cpgl.png" style="width:16px;margin-right:15px;">测评管理
        </router-link>
      </li>
      <li v-if="currentUserType=='enterprise'">
        <router-link to="/ability/enterprise_manage" :class="(selectIndex=='ability' || (selectIndex=='enterprise' && fullPath !='/enterprise/enterprise_interview_list' && fullPath!='/enterprise/interview_manage'))?'accordion-toggle wave-effect select-menu':'accordion-toggle wave-effect'"  data-toggle="collapse">
          <img src="@/assets/images/menu/menu-qygl.png" style="width:16px;margin-right:15px;">企业管理
        </router-link>
      </li>

      <!-- <li v-if="currentUserType=='enterprise'">
        <router-link to="#" class="accordion-toggle wave-effect" data-toggle="collapse">
          —企业新旧菜单分割线—
        </router-link>
      </li>

      <li v-if="currentUserType=='enterprise'">
        <router-link to="/data/center" class="accordion-toggle wave-effect" data-toggle="collapse">
          <i class="fa  fa-th mr-2"></i> Hiturn大数据
        </router-link>
      </li>

      <li v-if="currentUserType=='enterprise'">
        <router-link to="/cv/cv_manager" class="accordion-toggle wave-effect" data-toggle="collapse">
          <i class="fa  fa-calendar mr-2"></i> 简历管理
        </router-link>
      </li>

      <li v-if="currentUserType=='enterprise'">
        <router-link to="/job/job_manager" class="accordion-toggle wave-effect" data-toggle="collapse">
          <i class="fa fa-archive mr-2"></i> 职位管理
        </router-link>
      </li>

      <li v-if="currentUserType=='enterprise'">
        <router-link to="/enterprise/enterprise_interview_list" class="accordion-toggle wave-effect" data-toggle="collapse">
          <i class="fa fa-dedent mr-2"></i> 面试邀请管理
        </router-link>
      </li>

      <li v-if="currentUserType=='enterprise'">
        <router-link to="/ai/interview" class="accordion-toggle wave-effect" data-toggle="collapse">
          <i class="fa fa-briefcase mr-2"></i> AI面试
        </router-link>
      </li>
      <li v-if="currentUserType=='enterprise'" class="">
        <router-link to="/?pageFrom=index" class="accordion-toggle wave-effect" data-toggle="collapse">
          <i class="fa fa-desktop mr-2"></i> 人才搜索
        </router-link>
      </li> -->
      <!--
      <li v-if="currentUserType=='enterprise'">
        <router-link to="/job/job_pub" class="accordion-toggle wave-effect" data-toggle="collapse">
          <i class="fa fa-external-link mr-2"></i> 发布职位
        </router-link>
      </li>
      -->

      <!-- <li v-if="currentUserType=='enterprise'">
        <router-link to="/enterprise/enterprise_info_view" class="accordion-toggle wave-effect" data-toggle="collapse" v-if="$store.getters.enterpriseInfo.checkState==-1">
          <i class="fa fa-bars mr-2"></i> 企业信息
        </router-link>
        <router-link to="/enterprise/enterprise_info_detail" class="accordion-toggle wave-effect" data-toggle="collapse" v-if="$store.getters.enterpriseInfo.checkState!=-1">
          <i class="fa fa-bars mr-2"></i> 企业信息
        </router-link>
      </li>

      <li v-if="currentUserType=='enterprise'">
        <router-link to="/enterprise/enterprise_comment_honor" class="accordion-toggle wave-effect" data-toggle="collapse">
          <i class="fa  fa-bank mr-2"></i> 合规信誉认证
        </router-link>
      </li>
      <li v-if="currentUserType=='enterprise'">
        <router-link to="/article/hiturn_enterprise" class="accordion-toggle wave-effect" data-toggle="collapse">
          <i class="fa fa-user-circle-o mr-2"></i> 客户服务
        </router-link>
      </li>
      <li v-if="currentUserType=='enterprise'">
        <router-link to="/exam/exam_manager" class="accordion-toggle wave-effect" data-toggle="collapse">
          <i class="fa fa-list-alt mr-2"></i> 测评管理
        </router-link>
      </li>
      <li v-if="currentUserType=='enterprise'">
        <router-link to="/tools/hr" class="accordion-toggle wave-effect" data-toggle="collapse">
          <i class="fa fa-steam-square mr-2"></i> eHR工具
        </router-link>
      </li>
      <li v-if="currentUserType=='enterprise'">
        <router-link to="/ability/ability_index" class="accordion-toggle wave-effect" data-toggle="collapse">
          <i class="fa fa-money mr-2"></i> 套餐购买
        </router-link>
      </li> -->
      <!--
      <li v-if="currentUserType=='enterprise'">
        <router-link to="/ability/ability_list" class="accordion-toggle wave-effect" data-toggle="collapse">
          <i class="fa fa-credit-card mr-2"></i> 购买套餐
        </router-link>
      </li>
      <li v-show="currentUserType=='enterprise'">
        <a href="#homeSubmenu" class="accordion-toggle wave-effect" data-toggle="collapse"
           aria-expanded="false">
          <i class="fa fa-adjust mr-2"></i> 简历库
        </a>
      </li>-->

      <!-- 个人菜单 -->
      <li v-if="currentUserType=='personal'" class="">
        <router-link to="/home" :class="selectIndex=='home'?'accordion-toggle wave-effect select-menu':'accordion-toggle wave-effect'" data-toggle="collapse">
          <img src="@/assets/images/menu/menu-sy.png" style="width:16px;margin-right:15px;">首页
        </router-link>
      </li>
      <li v-if="currentUserType=='personal'" class="">
        <router-link to="/index" :class="selectIndex=='index'?'accordion-toggle wave-effect select-menu':'accordion-toggle wave-effect'" data-toggle="collapse">
          <img src="@/assets/images/menu/menu-wdqz.png" style="width:16px;margin-right:15px;">我的求职
        </router-link>
      </li>
      <li v-if="currentUserType=='personal'">
        <router-link to="/cv" :class="(selectIndex=='cv' && fullPath!='/cv/personal_profile')?'accordion-toggle wave-effect select-menu':'accordion-toggle wave-effect'" data-toggle="collapse">
          <img src="@/assets/images/menu/menu-jlgl.png" style="width:16px;margin-right:15px;">我的简历
        </router-link>
      </li>

      <li v-if="currentUserType=='personal'">
        <router-link to="/job/my_interview_list" :class="fullPath=='/job/my_interview_list'?'accordion-toggle wave-effect select-menu':'accordion-toggle wave-effect'" data-toggle="collapse">
          <img src="@/assets/images/menu/menu-zwgl.png" style="width:16px;margin-right:15px;">我的邀约
        </router-link>
      </li>



      <li v-if="currentUserType=='personal'">
        <router-link to="/job/job_list_view" :class="(selectIndex=='job' && fullPath!='/job/my_interview_list')?'accordion-toggle wave-effect select-menu':'accordion-toggle wave-effect'"  data-toggle="collapse">
          <img src="@/assets/images/menu/menu-rcss.png" style="width:16px;margin-right:15px;">职位搜索
        </router-link>
      </li>


      <li v-if="currentUserType=='personal'">
        <router-link to="/data/center" :class="selectIndex=='data'?'accordion-toggle wave-effect select-menu':'accordion-toggle wave-effect'"  data-toggle="collapse">
          <img src="@/assets/images/menu/menu-msgl.png" style="width:16px;margin-right:15px;">求职大数据
        </router-link>
      </li>
      <li v-if="currentUserType=='personal'">
        <!--<router-link to="/exam/my_exam_list" class="accordion-toggle wave-effect" data-toggle="collapse">
          <i class="fa fa-behance mr-2"></i> 我的测评
        </router-link>-->
        <router-link to="/exam/user_exam_manager" :class="selectIndex=='exam'?'accordion-toggle wave-effect select-menu':'accordion-toggle wave-effect'"  data-toggle="collapse">
          <img src="@/assets/images/menu/menu-rccp.png" style="width:16px;margin-right:15px;">人才测评
        </router-link>
      </li>
      <li v-if="currentUserType=='personal'">
        <router-link to="/ai/interview" :class="selectIndex=='ai'?'accordion-toggle wave-effect select-menu':'accordion-toggle wave-effect'" data-toggle="collapse">
          <img src="@/assets/images/menu/menu-aims.png" style="width:16px;margin-right:15px;">AI面试
        </router-link>
      </li>
      <!--
      <li>
        <router-link to="/article/hiturn_good_enterprise" class="accordion-toggle wave-effect" data-toggle="collapse">
          <i class="fa fa-file-text-o mr-2"></i> 本地优质企业推介
        </router-link>
      </li>
      -->
      <!-- <li v-if="currentUserType=='personal'">
        <router-link to="/cv/personal_profile" :class="fullPath=='/cv/personal_profile'?'accordion-toggle wave-effect select-menu':'accordion-toggle wave-effect'"  data-toggle="collapse">
          <img src="@/assets/images/menu/menu-grxxzl.png" style="width:16px;margin-right:15px;">个人信息总览
        </router-link>
      </li> -->
      <!-- <li v-if="currentUserType=='personal'">
        <router-link to="/article/hiturn_personal" class="accordion-toggle wave-effect" data-toggle="collapse">
          <img src="@/assets/images/menu/menu-xxcz.png" style="width:16px;margin-right:15px;">个人服务
        </router-link>
      </li> -->
      <li v-if="currentUserType=='personal'">
        <!-- <router-link to="http://qy.yingsheng.com/21646" class="accordion-toggle wave-effect" data-toggle="collapse">
          <img src="@/assets/images/menu/menu-xxcz.png" style="width:16px;margin-right:15px;">学习成长
        </router-link> -->
        <!-- <router-link target="_blank" :to="{path:'http://qy.yingsheng.com/21646'}">
            <img src="@/assets/images/menu/menu-xxcz.png" style="width:16px;margin-right:15px;">学习成长
        </router-link> -->
        <!-- <a href="http://qy.yingsheng.com/21646" target="_blank">
            <img src="@/assets/images/menu/menu-xxcz.png" style="width:16px;margin-right:15px;">学习成长
        </a> -->

        <router-link to="/studyAndGrow" :class="selectIndex=='studyAndGrow'?'accordion-toggle wave-effect select-menu':'accordion-toggle wave-effect'" data-toggle="collapse">
          <img src="@/assets/images/menu/menu-xxcz.png" style="width:16px;margin-right:15px;">学习成长
        </router-link>

      </li>

     <!-- <li v-if="currentUserType=='enterprise'">
        <router-link to="/tools/ehr" class="accordion-toggle wave-effect" data-toggle="collapse">
          <i class="fa fa-briefcase mr-2"></i> eHR工具
        </router-link>
      </li>-->

      <!-- 公共菜单 -->
      <li>
        <router-link  :to="{path: '/fair/default'}" target="_blank"  class="accordion-toggle wave-effect">
          <img src="@/assets/images/menu/menu-yzph.png" style="width:16px;margin-right:15px;">招聘会云平台
        </router-link>
      </li>

      <li v-if="currentUserType=='enterprise'">
        <router-link to="/job/my_fair_list" :class="selectIndex=='fairlist'?'accordion-toggle wave-effect select-menu':'accordion-toggle wave-effect'">
          <img src="@/assets/images/menu/menu-jlgl.png" style="width:16px;margin-right:15px;">招聘会数据填报
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>

    export default {
        name: "Nav",
        data() {
            return {
                hashNewInterview: false,
                newInterviewNum: "0",
                data: {
                    size:10,
                    page:1,
                    recordCount:0
                },
                interviewState: 0,
                selectIndex:'',
                fullPath:''
            }
        },
        mounted() {
          const to = this.$route
          this.computeRoute(to)
        },
       computed:{
        currentUserType:{
          get: function () {
            return this.$store.getters.userType
          }
        }
      },
      methods:{
        getCheckStateVisible(){
          if (this.$store.getters.enterpriseInfo.checkState == 1){
            return true
          }else{
            return false
          }
        },
        computeRoute(to){
          const selectIndex = to.fullPath.split('/')[1]
          if(to.path == '/job/job_apply_list/999999999/100'){
            this.selectIndex = 'cv'
          }else if(to.path == '/index'){
            this.selectIndex = 'index'
          }else if(to.path == '/job/my_fair_list'){
            this.selectIndex = 'fairlist'
          }else{
            this.selectIndex = selectIndex
          }
          this.fullPath = to.fullPath
        }
      },
      watch: {
        $route(to,from){
          //我的求职保留条件to.path.indexOf('job/job_detail')>0
          if(!((from.path.indexOf('job/job_detail')>0 && to.path=='/index') || (to.path.indexOf('job/job_detail')>0 && from.path=='/index'))){
            localStorage.removeItem('my_apply_job_status');
            localStorage.removeItem('my_apply_job_data');
          }
          //查询简历条件保留
          if(!((from.path=='/cv/cv_view/cv_view' && to.path=='/index') || (to.path=='/cv/cv_view/cv_view' && from.path=='/index'))){
            localStorage.removeItem('cv_query_params');
          }
          //查询职位申请条件保留
          if(!((from.path=='/cv/cv_view/cv_view_ent' && to.path=='/job/job_apply_list/999999999/100') || (to.path=='/cv/cv_view/cv_view_ent' && from.path=='/job/job_apply_list/999999999/100'))){
            localStorage.removeItem('apply_query_params');
          }
         // 简历未完成，不能做其他操作
          if (this.$store.getters.userType == 'personal'){
              var cvState= this.$store.getters.userInfo.cvState;
              if(cvState!='2'){
                if(to.path.indexOf('/cv/cv_edit')<0){
                    this.$router.push({
                      path:'/cv/cv_no_finish'
                    })
                }
              }
          }
          this.computeRoute(to)
        }
      }
    }
</script>

<style scoped>
  .img-circle {
    border-radius: 100%;
  }
  .nav-sidebar a, .nav-sidebar a:focus, .nav-sidebar a:hover {
    color: inherit;
    text-decoration: none;
    -webkit-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
  }
  .nav-sidebar a::before {
    font-family: "themify";
  }
  .line {
    width: 100%;
    height: 1px;
    border-bottom: 1px dashed #ddd;
    margin: 40px 0;
  }
  /* ---------------------------------------------------
      NAVBAR STYLE
  ----------------------------------------------------- */

  .theme-color {
    background: #fff !important;
  }
  .navbar {
    padding: 0;
  }
  .navbar .menu-toggle-button a {
    padding: 1.1rem 1rem;
    color: #FFF;
  }
  .navbar .menu-toggle-button a:hover {
    background: rgba(0, 0, 0, 0.1);
  }
  /* ---------------------------------------------------
      SIDEBAR STYLE
  ----------------------------------------------------- */

  #sidebar {
    min-width: 240px;
    max-width: 240px;
    -webkit-box-shadow: 1px 0 20px rgba(0, 0, 0, 0.08);
    box-shadow: 0 16px 26px 0 rgba(119, 119, 119,0.1), 0 3px 6px 0 rgba(119, 119, 119,0.1);
    color: #fff;
    -webkit-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    z-index: 10;
    background-image: linear-gradient(to left,#9853af,#623AA2);
    position:relative;
    background-size:cover;
    background-position:fixed;

background-color: #454646;
  }
  #sidebar:before{
    content:'';
    background:#25202d;
    position:absolute;
    width:100%;
    height:100%;
    display:block;
    background: #454646;

  }
  #sidebar .sidebar-header {
    padding: 10px;
    background: #0061da;
    text-align: center;
  }
  #sidebar .sidebar-header p {
    color: #FFF;
  }
  #sidebar ul.components {
    padding: 10px 0;
  }
  #sidebar ul p {
    color: #fff;
    padding: 10px;
  }
  #sidebar ul li a {
    padding: 10px;
    display: block;
    padding: 10px 20px 10px 35px;
    /* color:#e7ddf5; */
    color: #ffffff;
  }
  #sidebar ul.collapse li a:hover{
    color:#ad5df3;
  }
  #sidebar ul.collapse.show li.active>a:hover{
    color:#fff;
  }
  #sidebar ul li{
    border-bottom:0;
    background: #454646;
  }
  #accordion{
    background: #454646;}
  #sidebar li ul {
    /* background: rgb(255,255,255,0.04); */

    background: #454646;
  }
  #sidebar li ul li:before {

  }
  #sidebar ul li.active>a {
    color: #ad5df3;
    font-weight: 500;
    font-size:15px;
    background:transparent;
  }
  #sidebar ul li a{
    font-size:15px;
    font-weight:300;
  }
  #sidebar a[data-toggle="collapse"] {
    position: relative;
  }
  #sidebar li a[aria-expanded="false"]::before, #sidebar li a[aria-expanded="true"]::before {
    content: '\f054';
    display: block;
    position: absolute;
    right: 20px;
    top: 15px;
    font-size: 0.6em;
    font-family: fontawesome;
  }
  #sidebar li a[aria-expanded="true"]::before {
    content: '\f107';
    font-size: 1em;
    top: 10px;
  }
  #sidebar ul ul a {
    font-size: 0.9em !important;
    padding: 8px 10px 8px 55px !important;
  }
  #sidebar.active {
    margin-left: -240px;
  }
  /* ---------------------------------------------------
      CONTENT STYLE
  ----------------------------------------------------- */

  #content {
    min-height: 100vh;
    -webkit-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
  }
  /* ---------------------------------------------------
      MEDIAQUERIES
  ----------------------------------------------------- */

  @media (max-width: 768px) {
    #sidebar {
      margin-left: -240px;
      box-shadow: none;
    }
    #sidebar.active {
      margin-left: 0;
    }
    .nav-sidebar {
      position: absolute !important;
      z-index: 1;
    }
  }
  @media (max-width: 414px) {
    .menu-toggle-button {
      margin-top:8px !important;
    }
  }

  .menu-toggle-button {
    margin-top:12px;
    font-size: 20px;
    color:#fff;
  }
  ul {
    margin-top: 0;
    margin-bottom: 10px;
  }
  .user-profile {
    padding: 0 0 15px;
    position: relative;
    text-align: center;
    border-bottom:1px solid rgba(255,255,255,0.09);
  }
  .user-profile .user-pro-body {
    display: block;
  }
  .user-profile .user-pro-body img {
    width: 50px;
    display: block;
    margin: 0 auto 10px;
    border:2px solid #fff;
  }
  .user-profile .user-pro-body span.text-gray{
    color:#ad5df3 !important;
  }
  .user-profile .user-pro-body .u-dropdown {
    color: #97999f;
  }
  .user-profile .user-pro-body .dropdown-menu {
    right: 0;
    width: 80%;
    left: 0;
    margin: 0 auto;
    -webkit-transform: none !important;
    -ms-transform: none !important;
    transform: none !important;
    top: 85px !important;
  }
  .user-profile .user-pro-body .dropdown-menu li a {
    padding-left: 5px !important;
    padding-right: 10px !important;
    padding-top: 10px !important;
    padding: 10px !important;
  }
  .navbar-top-links .profile-pic {
    color: #FFF;
    text-decoration: none;
    padding: 0 12px;
  }
  .navbar-top-links .dropdown-menu li {
    display: block;
  }
  .navbar-top-links .dropdown-menu li:last-child {
    margin-right: 0;
  }
  .navbar-top-links .dropdown-menu li a {
    display: block;
    padding: 9px 20px;
    clear: both;
    font-weight: 400;
    line-height: 1.42857143;
    color: #333;
    white-space: nowrap;
  }
  .navbar-top-links .dropdown-menu li a:hover {
    background: #f7fafc;
    text-decoration: none;
  }
  .navbar-top-links .dropdown-user {
    right: 0;
    left: auto;
    position: absolute;
    width: 280px;
    margin-top: 10px;
  }
  .navbar-top-links .dw-user-box {
    padding: 15px;
  }
  .navbar-top-links .dw-user-box .u-img {
    width: 70px;
    display: inline-block;
    vertical-align: top;
  }
  .navbar-top-links .dw-user-box .u-img img {
    width: 100%;
    border-radius: 5px;
  }
  .navbar-top-links .dw-user-box .u-text {
    display: inline-block;
    padding-left: 10px;
  }
  .navbar-top-links .dw-user-box .u-text h4 {
    margin: 0;
  }
  .navbar-top-links .dw-user-box .u-text p {
    margin-bottom: 3px;
  }
  .navbar-top-links .dw-user-box .u-text .btn-danger {
    background: #f33155;
    opacity: .8;
    border-radius: 60px;
    border: 1px solid #f33155;
    padding: 5px 10px;
    font-size: 12px;
    line-height: 1.5;
    color: #FFF;
  }
  .card-login {
    max-width: 25rem;
  }
  .content-area .panel {
  }
  .top-inner-navbar {
    min-height: 57px;
  }
  .text-decoration-none:hover {
    text-decoration: none;
  }

  .avatar1 {
    width: 1.5rem;
    height: 1.5rem;
    line-height: 1.5rem;
    display: inline-block;
    background: #ff7088 no-repeat center/cover;
    position: relative;
    text-align: center;
    color: #fff;
    font-weight: 500;
    vertical-align: bottom;
    font-size: .750rem;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .select-menu{
    background: #90c31f;
    font-weight: 500 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue